import { Platform } from 'ionic-angular';
import { NL_IMAGE } from './../../models/NL_Image';
import { BllOrtak } from './bll-ortak';
import { Injectable } from "@angular/core";
import { Database } from './../database';
import 'rxjs/add/operator/map';
import { Ortak } from "../ortak";
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { File } from '@ionic-native/file';

@Injectable()
export class BllResimler extends Database {

    storageDirectory: string = '';
    constructor(public ortak: Ortak,
        public bllOrtak: BllOrtak,
        public platform: Platform,
        private transfer: FileTransfer,
           ) {
        super("NL_Image");
    }
    syncResimler() {
        return new Promise((res, err) => {
            var file = new File();
            const fileTransfer: FileTransferObject = this.transfer.create();
            var formData = new FormData();
            formData.append("image_type", "255");
            formData.append("source_ref", "-1");
            this.bllOrtak.islem(formData, "ResimListele", "", false).then(a => {
                this.deleteAll2().then(b => {
                    var sonuc = <any>a;
                    var eklenecekResimler: NL_IMAGE[] = sonuc.SonucObject;
                    var count = eklenecekResimler.length;
                    var eklenenCount = 0;
                    eklenecekResimler.forEach(element => {
                        eklenenCount = eklenenCount + 1;
                        var localPath = file.dataDirectory + element.Image_Name + "." + element.Image_Ext;
                        var downloadPath = this.ortak.storageServisBilgisiGetir.ADRES + element.Image_Path + "/" + element.Image_Name + "." + element.Image_Ext;
                        element.Image_Path = localPath;
                        element.IMAGE_URL = downloadPath;
                        this.addOrUpdate(element).then(c => {
                            fileTransfer.download(downloadPath, this.storageDirectory + 'asd.jpg').then((entry) => {

                                this.ortak.showBasicAlert("Başarılı", entry.toURl())
                            }, (error) => {


                                this.ortak.showBasicAlert("hata", error);

                            });

                            if (eklenenCount >= count) {
                                res();
                            }
                        })
                    });

                }).catch(y => {
                    err(y);
                })

            }).catch(x => {
       
                err(x);
            })
        })
    }


}


// WEBPACK FOOTER //
// ./src/providers/bll/bll-resimler.ts